import { rawData } from "../rawData";
import config from "../config.json";

const { dataSettings } = config;
const { uid } = dataSettings;
const getBasicMetadataFromIds = (arrayOfIds) => {
  const filteredData = rawData.filter((d) => arrayOfIds.includes(d[uid]));
  const selectedProperties = filteredData.map(
    ({ doi, var_name, var_label, table_name, table_dir_name }) => {
      return { table_dir_name, table_name, doi, var_name, var_label };
    }
  );

  return selectedProperties;
};

export { getBasicMetadataFromIds };
